module.exports = __webpack_public_path__ + "static/media/difficulty-breathing.d6cb5e36.svg";